import type {HistoryStateDrawing} from '@PosterWhiteboard/poster/poster-history/history-state-drawing';
import type {HistoryStatePoster} from '@PosterWhiteboard/poster/poster-history/history-state-poster';
import type {HistoryStatePosterDiff} from '@PosterWhiteboard/poster/poster-history/history-state-poster-diff';
import type {HistoryStatePosterOps} from '@PosterWhiteboard/poster/poster-history/history-state-poster-ops';

export type HistoryStates = HistoryStateDrawing | HistoryStatePoster | HistoryStatePosterDiff | HistoryStatePosterOps;

export enum HistoryDirection {
  UNDO = 'undo',
  REDO = 'redo',
}
